'use es6';

import { useEffect, useState } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { useSelector } from 'react-redux';
import { checkAccessRequirements } from '../utils/accessControlUtils';
import { COLLECTION_ACCESS } from '../constants/accessControl';
import { getGatesAndScopes } from '../selectors/gatesSelector';
export const useAnalyticsPermissions = () => {
  const [analyticsPermissions, setAnalyticsPermissions] = useState(ImmutableMap());
  const userAccessControls = useSelector(getGatesAndScopes);
  useEffect(() => {
    let permissionsMap = ImmutableMap({});
    COLLECTION_ACCESS.forEach((accessControl, navItemId) => {
      const navData = ImmutableMap(Object.assign({}, checkAccessRequirements(Object.assign({}, userAccessControls, {
        accessControl
      })), {
        upgradePoint: accessControl.get('upgradePoint')
      }));
      permissionsMap = permissionsMap.set(navItemId, navData);
    });
    setAnalyticsPermissions(permissionsMap);
  }, [userAccessControls]);
  return analyticsPermissions;
};